import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_components_for_process_orderService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { order_id: number, manufacturing_warehouse_id: number, $top?: number, $skip?: number }): Promise<{ result?: { Material?: { Id?: number, Name?: string }, FinishedProduct?: { Id?: number, Name?: string }, PlannedQuantity?: number, Packaging?: string, OrderLineId?: number, IsNormalWaveRelease?: boolean, IsSufficient?: boolean, Availability?: string, SourceWarehouses?: string[], TotalInventory?: number }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.order_id)) {
      missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil(inParams.manufacturing_warehouse_id)) {
      missingRequiredInParams.push('\'manufacturing_warehouse_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_components_for_process_order/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { order_id?: number, manufacturing_warehouse_id?: number, $keys: number[] }): Promise<{ result?: { Material?: { Id?: number, Name?: string }, FinishedProduct?: { Id?: number, Name?: string }, PlannedQuantity?: number, Packaging?: string, OrderLineId?: number, IsNormalWaveRelease?: boolean, IsSufficient?: boolean, Availability?: string, SourceWarehouses?: string[], TotalInventory?: number }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_components_for_process_order/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      order_id: number, manufacturing_warehouse_id: number    }) {
        if(isNil(inParams.order_id)) {
          return true; 
        }
        if(isNil(inParams.manufacturing_warehouse_id)) {
          return true; 
        }
      return false;
    }
}
